import React, { useImperativeHandle, useRef, useEffect, forwardRef, useState } from "react";
import { Modal } from 'bootstrap';
import Loader from "../../../components/ui/Loader/Loader";
import HttpAPICall from "../../../services/HttpAPICall";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { BACKOFFICE_BASE_URL } from "../../../services/TapApiUrls";
import TapIcon from "../../../services/TapIcon";
import TapSelect from "../../../components/ui/TapSelect";

const SimLinking = forwardRef(({ detailData, onLinkSuccess }, ref) => {
    const [submitLoading, setSubmitLoading] = useState(false);

    const [mobileOptions, setMobileOptions] = useState([]);
    const [simDataLoading, setSimDataLoading] = useState(false);
    const [formData, setFormData] = useState({
        sim_id: "",
        device_id: ""
    });


    const access_token = useSelector(state => state.auth.access_token);

    const modalElem = useRef(null);
    const searchModal = useRef(null);
    useImperativeHandle(ref, () => ({
        initModalDataHandler: () => {
            searchModal.current.show();
            setFormData(prev => ({
                ...prev,
                device_id: detailData.id,
            }));
        }
    }));

    useEffect(() => {
        fetchMobileNumbers();
    }, []);

    const fetchMobileNumbers = async () => {
        try {
            setSimDataLoading(true);
            const resp = await HttpAPICall.withAthorization(
                "GET",
                BACKOFFICE_BASE_URL + "/sim_linking_form_data",
                access_token,{}, {}
            );
            const options = resp.data.map(item => ({
                label: `${item.sim_number} (${item.mobile_number})`,
                value: item.id
            }));
            setMobileOptions(options);
        } finally {
            setSimDataLoading(false);
        }
    };

    useEffect(() => {
        modalElem.current = document.getElementById("simLinkingID");
        searchModal.current = new Modal(modalElem.current, { keyboard: false, backdrop: false });
        return () => {
            if (searchModal.current) {
                searchModal.current.dispose();
            }
        }
    }, []);
    const searchModalClose = () => {
        searchModal.current && searchModal.current.hide();
        resetForm()
    };
    const resetForm = () => {
        setFormData({
            device_id: "",
            sim_id: ""
        });
    };

    const submitData = (e) => {
        e.preventDefault();
        const payload = {
            device_id: formData.device_id,
            sim_id: formData.sim_id
        };
        setSubmitLoading(true);
        HttpAPICall.withAthorization(
            "POST", BACKOFFICE_BASE_URL + "/sim_device_linking", access_token, {}, payload,
            (resp) => {
                toast.success(resp.data.msg);
                searchModalClose();
                onLinkSuccess && onLinkSuccess(formData.device_id);

            }
        ).then(() => setSubmitLoading(false));
    };


    return (
        <>
            <div className="modal fade" id={"simLinkingID"} tabIndex="-1" ref={modalElem}>
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="simLinkingModalLabel">Sim Linking </h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"  onClick={searchModalClose}></button>
                        </div>
                        <div className="modal-body">
                            <form id="simLinkingForm" onSubmit={submitData}>
                                {simDataLoading ? <Loader /> :
                                    <div className="row align-items-center my-3">
                                        <div className="col-md-3">
                                            <label htmlFor="path" className="form-label require">Sim Linking</label>
                                        </div>
                                        <div className="col-md-6">
                                            <TapSelect
                                                options={mobileOptions}
                                                isSearchable
                                                isClearable
                                                required
                                                placeholder="Select Mobile Number"
                                                changeEvent={(selected) => {
                                                    setFormData(prev => ({
                                                        ...prev,
                                                        sim_id: selected ? selected.value : ""
                                                    }));
                                                }}
                                                value={mobileOptions.find(s => s.value === formData.sim_id)}
                                            />
                                        </div>
                                    </div>}
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={searchModalClose} data-bs-dismiss="modal">Close</button>
                                    <button type="submit" className="btn btn-primary mx-2" disabled={submitLoading}>
                                        Save {submitLoading ? (<TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin" />) : ''}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
});

export default SimLinking;
